var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main__back"},[_c('a',{staticClass:"main__back-text",attrs:{"href":""},on:{"click":_vm.toggleButton}},[_c('i',{staticClass:"fas fa-arrow-left back"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }